
import GoogleMapLine from "./GoogleMapLine.vue";
import GoogleMapLoader from "./GoogleMapLoader.vue";
import GoogleMapMarker from "./GoogleMapMarker.vue";
import { mapSettings } from "@/constants/mapSettings";
import Vue, { PropType } from "vue";

export default Vue.extend({
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine,
  },

  props: {
    markers: {
      type: Array as () => {
        id: string;
        position: { lat: number; lng: number };
      }[],
      default: () => [],
    },
    google: {
      type: Array as unknown as PropType<
        [
          google.maps.PlacesLibrary,
          google.maps.MapsLibrary,
          google.maps.CoreLibrary
        ]
      >,
      required: true,
    },
  },

  data() {
    return {
      lines: [] as { id: string; path: google.maps.LatLngLiteral[] }[],
      marker2: [
        { id: "a", position: { lat: 38.365708, lng: -121.956613 } },
        { id: "b", position: { lat: -121.956613, lng: 38.365708 } },
        { id: "c", position: { lat: 6, lng: 97 } },
      ],
    };
  },

  computed: {
    mapConfig(): { center: { lat: number; lng: number }; [key: string]: any } {
      return {
        ...mapSettings,
        center: this.markers[0].position,
        mapId: this.$config.mapId,
      };
    },
    mapCenter(): { lat: number; lng: number } {
      return this.markers[0].position;
    },
  },
});
